export default __webpack_public_path__ + "static/dxbot-43e0efe26847caf0030af2b6468fa030.png";